var API_V1_PREFIX = "/api/v1";
export var API_ENDPOINTS = {
    agent: "".concat(API_V1_PREFIX, "/agent"),
    fixedQuery: "".concat(API_V1_PREFIX, "/fixed-query"),
    cache: "".concat(API_V1_PREFIX, "/cache"),
    dashboardCatalog: "".concat(API_V1_PREFIX, "/dashboard/catalog"),
    dashboardSubtabFilters: function (sectionId, subtabId) {
        return "".concat(API_V1_PREFIX, "/dashboard/").concat(encodeURIComponent(sectionId), "/").concat(encodeURIComponent(subtabId), "/filters");
    },
    dashboardChartEndpoint: function (sectionId, subtabId, chartId) {
        var _a, _b;
        var slug = (_b = (_a = chartId.split(".").at(-1)) === null || _a === void 0 ? void 0 : _a.replace(/_/g, "-")) !== null && _b !== void 0 ? _b : chartId;
        return "".concat(API_V1_PREFIX, "/dashboard/").concat(encodeURIComponent(sectionId), "/").concat(encodeURIComponent(subtabId), "/charts/").concat(encodeURIComponent(slug));
    },
    dashboardKpisEndpoint: function (sectionId, subtabId) {
        return "".concat(API_V1_PREFIX, "/dashboard/").concat(encodeURIComponent(sectionId), "/").concat(encodeURIComponent(subtabId), "/kpis");
    },
};
